import React from "react";
import { FormattedMessage, MessageDescriptor } from "react-intl";

interface SafeFormattedMessageProps {
	messages: { [key: string]: MessageDescriptor };
	messageKey: string;
	values?: { [key: string]: any };
}

export const SafeFormattedMessage: React.FunctionComponent<
	SafeFormattedMessageProps
> = ({ messages, messageKey, values }) => {
	if (!(messageKey in messages)) {
		console.error("message not found", { messages, key: messageKey });
		return null;
	}
	return <FormattedMessage {...messages[messageKey]} values={values} />;
};
